import {User}									from '../user/interface';
import {ApiDeleteUserState, ApiUserState, PostUserData,
	PutUserData, UploadProfilePictureState}		from './interface';

import * as API									from '../../ressources/API';


export default {
	getCompanyUsersApi: async (user: User) => {
		const response = await API.getUsers(user);
		if (!response || !response.status)
			return [];
		return response.data;
	},
	postCompanyUsersApi: async (data: ApiUserState) => {
		const response = await API.postUser(data.data as PostUserData, data.user);
		if (!response || !response.status)
			return {error: response.error};
		return response.data;
	},
	putCompanyUsersApi: async (data: ApiUserState) => {
		if (!data.idUser)
			return null;

		const response = await API.putUser(data.idUser, data.data as PutUserData, data.user);
		if (!response || !response.status)
			return response;
		return response.data;
	},
	uploadProfilePicture: async (data: UploadProfilePictureState) => {
		const response = await API.uploadProfilePicture(data.idUser, data.file, data.user);
		if (!response || !response.status)
			return null;
		return response.data;
	},
	deleteCompanyUsersApi: async (data: ApiDeleteUserState) => {
		const response = await API.deleteUser(data.idUser, data.user);
		if (!response || !response.status)
			return null;
		return data.idUser;
	}
};
